import { EMaterskaSpol } from 'enums/lei/materskaSpol';

export const leiMaMaterskouSpolPrimaSelect = [
    {
        labelcz: 'LEI_MATKA_UVEST',
        value: EMaterskaSpol.ANO
    },
    {
        labelcz: 'LEI_MATKA_NEUVEST',
        value: EMaterskaSpol.NE
    }
];
export const leiMaMaterskouSpolFinalSelect = [
    /* {
        labelcz: 'NELZE_UVEST',
        value: EMaterskaSpol.NELZE_UVEST
    },*/
    {
        labelcz: 'LEI_MATKE_STEJNE_HODNOTY',
        value: EMaterskaSpol.ANO_SAME
    }
];
